<template>
  <v-row
    no-gutters
    dense
  >
    <v-col cols="12">
      <v-card
        outlined
      >
        <v-card-text>
          <v-row no-gutters dense>
            <v-col cols="12">
              <div class="subtitle-2 mb-1">Payment Method</div>
              <v-radio-group
                v-model="paymentMethod"
                :disabled="loading"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="method in paymentMethods"
                  :key="method.value"
                  :label="method.text"
                  :value="method.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-row no-gutters dense>
              <v-col cols="2" >
                <v-text-field
                  v-if="$store.state.user.user_settings.userId != 245"
                  label="Amount"
                  :rules="[rules.required, rules.minimumtopup]"
                  :disabled="loading"
                  v-model="amount"></v-text-field>
                <v-text-field
                  v-if="$store.state.user.user_settings.userId == 245"
                  label="Amount"
                  :rules="[rules.required]"
                  :disabled="loading"
                  v-model="amount"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters dense v-if="paymentMethod == 1">
              <v-col cols="2" >
                <v-text-field label="Bank"
                              :rules="[rules.required]"
                              v-model="bank"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Reference No"
                              :rules="[rules.required]"
                              v-model="referenceNo"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Transfer Datetime"
                              :rules="[rules.required]"
                              v-model="transferDatetime"
                              @click.prevent="openDatetimePicker($event)"
                              :readonly="true"
                ></v-text-field>
                <datetime
                  class="datetime-picker"
                  ref="datetimePicker"
                  type="datetime"
                  v-model="pickerTransferDatetime"
                  :hour-step="1"
                  :minute-step="5"
                  format="yyyy-MM-dd HH:mm:ss"
                  auto
                ></datetime>
              </v-col>
            </v-row>
            <div v-if="paymentMethod == 3">
              <v-radio-group v-model="stripePaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <stripe-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></stripe-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <stripe-payment
                      :amount="amount"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></stripe-payment>
                  </v-col>
                </v-row>
                <v-row no-gutters dense v-if="!airwallexAvailable">
                  <v-col cols="12">
                    <v-checkbox
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
            <div v-if="paymentMethod == 4">
              <v-radio-group v-model="paypalPaymentMode">
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <paypal-saved-cards
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      v-on:remove-card="hasSavedCard = false"
                    ></paypal-saved-cards>
                  </v-col>
                </v-row>
                <v-row v-if="hasSavedCard && !airwallexWalletSelected"></v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <paypal-payment
                      :amount="amount"
                      :orderid="paypalOrderId"
                      @interface="getChildInterface"
                      :saveasdefaultcard="saveAsDefaultCard"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></paypal-payment>
                  </v-col>
                </v-row>
                <v-row no-gutters dense v-if="!airwallexAvailable">
                  <v-col cols="12">
                    <v-checkbox
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
            <div v-if="paymentMethod == 6">
              <div v-if="paynowReady">
                <img :src="paynowImage" width="160">
                <p>PAYNOW QR Code is valid for 1 hour.</p>
              </div>
            </div>
            <div v-if="[7, 8].includes(paymentMethod)">
              <v-radio-group
                v-model="airwallexPaymentMode"
                :disabled="loading || airwallexSavedCardsBusy"
              >
                <v-radio value="useSavedCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use saved card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="6">
                    <airwallex-saved-cards v-if="!airwallexWalletSelected"
                      :card.sync="savedCard"
                      :hasCard.sync="hasSavedCard"
                      :busy.sync="airwallexSavedCardsBusy"
                      :disabled="loading"
                      v-on:remove-card="hasSavedCard = false"
                    ></airwallex-saved-cards>
                  </v-col>
                </v-row>
                <v-radio value="useNewCard" v-if="hasSavedCard && !airwallexWalletSelected">
                  <template v-slot:label>
                    <div>Use new card</div>
                  </template>
                </v-radio>
                <v-row no-gutters dense>
                  <v-col cols="12" md="6">
                    <airwallex-payment
                      :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                      @apple-pay-selected="selectAirwallexApplePay"
                      :amount="amount"
                      :invalid.sync="creditCardInvalid"
                      :disabled="loading || airwallexSavedCardsBusy"
                      @interface="getAirwallexInterface"
                    ></airwallex-payment>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-form>
          <v-row no-gutters dense>
            <v-col cols="12" class="text-right">
              <v-tooltip bottom
                v-if="((paymentMethod === 3 && stripePaymentMode !== 'useSavedCard'
                     && !airwallexAvailable) ||
                   (paymentMethod === 4 && paypalPaymentMode !== 'useSavedCard'
                     && !airwallexAvailable) ||
                   ([7, 8].includes(paymentMethod) && airwallexPaymentMode !== 'useSavedCard'))"
              >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="success"
                      :loading="loading"
                      :disabled="(airwallexSavedCardsBusy
                        || ([7, 8].includes(paymentMethod)
                          && (loading
                            || creditCardInvalid !== false
                            || !airwallexInterfaceReady))) || airwallexWalletSelected"
                      v-bind="attrs"
                      v-on="on"
                      @click="saveCard">
                      Save Card Only
                    </v-btn>
                    <span>&nbsp;Or&nbsp;</span>
                </template>
                <span v-if="[7, 8].includes(paymentMethod)">
                  Your card will be verified for future payments. Complete 3D Secure if prompted;
                  no $5 payment will be taken.
                </span>
                <span v-else>
                  $5 will be authenticated for validation; there is no actual charge.
                </span>
              </v-tooltip>
              <v-btn color="primary"

                     :loading="loading"
                     :disabled="airwallexSavedCardsBusy"
                     @click="submit">
                <span v-if="paymentMethod !== 6">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Topup Now (Visa/Master)' }}
                </span>
                <span v-else>Topup Now (Paynow)</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-row
        dense
      >
        <v-col cols="12">
          <h4>Auto Top-up</h4>
        </v-col>
      </v-row>
      <v-row
        dense
      >
        <v-col cols="2">
          <v-checkbox
            v-model="form.enable_auto_topup"
            label="Enable Credit Card auto top-up"
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="form.minimum_threshold_amount"
            label="When Below :"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="form.auto_topup_amount"
            label="Deposit Amount :"
            :rules="[rules.minimumtopup2]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4">
          <v-checkbox
            v-model="form.allow_threshold_email"
            label="Email notification when below threshold"
          ></v-checkbox>
        </v-col>
        <v-col  cols="4"
                v-if="$store.state.adminUser.role && 'Admin' === $store.state.adminUser.role">
          <v-checkbox
            v-model="form.allow_negative_email"
            label="Email notification when negative"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col
          cols="12"
          class="text-right"
        >
          <v-btn
            color="primary"
            :loading="processing"
            @click="submitForm"
          >Submit</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon';
import airwallexWallet from '../../../mixins/airwallex-wallet';
import {
  StripePayment, StripeSavedCards, PaypalPayment, PaypalSavedCards,
  AirwallexPayment, AirwallexSavedCards,
} from '../../components/payment_modules';
import {
  airwallexCustomerErrorMessage,
  clearAirwallexDirectTopup,
  creditCardPaymentSupportReferenceSuffix,
  creditCardPaymentMethodLabel,
  getAirwallexDirectTopup,
  getOrCreateAirwallexDirectTopup,
  isAirwallexTerminalRequestError,
  isValidAirwallexTopupAmount,
  pollAirwallexPayment,
  saveAirwallexCardConsent,
  saveAirwallexDirectTopup,
  toCreditCardPaymentMessage,
  validateAirwallexDirectTopupResponse,
} from '../../../plugins/airwallex-payment';
import {
  resolveAirwallexPaymentIntentId,
} from '../../../mixins/airwallex-recovery';

export default {
  mixins: [airwallexWallet],
  name: 'Topup',
  components: {
    StripeSavedCards,
    StripePayment,
    PaypalPayment,
    PaypalSavedCards,
    AirwallexPayment,
    AirwallexSavedCards,
  },
  data() {
    return {
      bank: '',
      referenceNo: '',
      transferDatetime: null,
      pickerTransferDatetime: null,
      paymentMethod: 4,
      paymentMethods: [],
      paypalOrderId: '',
      amount: '',
      loading: false,
      saveAsDefaultCard: true,
      creditCardInvalid: null,
      creditCard: null,
      savedCard: null,
      hasSavedCard: false,
      airwallexSavedCardsBusy: false,
      airwallexInterfaceReady: false,
      stripePaymentMode: 'useNewCard',
      paypalPaymentMode: 'useNewCard',
      airwallexPaymentMode: 'useNewCard',
      rules: {
        required: (value) => !!value || 'This field is required.',
        minimumtopup: (value) => {
          if (this.$store.state.adminUser.role && this.$store.state.adminUser.role === 'Admin') {
            return true;
          }

          return value >= 200 || 'Minimum top-up is $200.';
        },
        minimumtopup2: (value) => this.$underscore.isEmpty(value) || value >= 100 || 'Minimum top-up is $100.',
      },
      settingProcessing: false,
      form: {
        enable_auto_topup: false,
        minimum_threshold_amount: '',
        auto_topup_amount: '',
        allow_threshold_email: false,
        allow_negative_email: false,
      },
      paynowReady: 0,
      paynowImage: '#',
      paymentId: null,
      timer: null,
    };
  },
  created() {
    this.transferDatetime = DateTime.local().toFormat('yyyy-MM-dd HH:mm:ss');
    this.pickerTransferDatetime = DateTime.local().toISO();
    this.$api.get('partner/payment-methods').then((response) => {
      const paymentMethods = this.filterWalletPaymentMethods(response.data).map((method) => ({
        ...method,
        text: creditCardPaymentMethodLabel(method),
      }));

      this.$set(this, 'paymentMethods', paymentMethods);

      // The default method (PayPal) is hidden for Airwallex-stage
      // partners; fall back to Airwallex, or the first available method.
      const methodIds = paymentMethods.map((method) => method.id);
      if (methodIds.length && !methodIds.includes(this.paymentMethod)) {
        this.paymentMethod = methodIds.includes(7) ? 7 : methodIds[0];
      }
    });
    // this.$api.get('partner/default-payment-method').then((response) => {
    //   this.$set(this, 'paymentMethod', response.data);
    // });
    this.$api.get('partner/settings').then((response) => {
      this.setSettings(response.data);
    });
  },
  computed: {
    airwallexAvailable() {
      return this.paymentMethods.some((paymentMethod) => paymentMethod.id === 7);
    },
  },
  methods: {
    // Setting the interface when emitted from child
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getAirwallexInterface(childInterface) {
      const ready = !!childInterface
        && typeof childInterface.confirmIntent === 'function'
        && typeof childInterface.createConsent === 'function';

      this.$options.airwallexInterface = ready ? childInterface : null;
      this.airwallexInterfaceReady = ready;
    },
    getAirwallexDirectTopupContext(mode) {
      const paymentMode = Number(this.paymentMethod) === 8 ? 'apple_pay' : mode;
      const user = this.$store.state.user || {};
      const userSettings = user.user_settings || {};
      const brand = this.$store.state.brand || 'gce';

      return {
        brand,
        currency: window.systemCurrency,
        environment: process.env.VUE_APP_AIRWALLEX_ENV,
        accountScope: 'gce',
        userId: user.id || userSettings.userId || null,
        mode: paymentMode,
        cardId: mode === 'saved' && this.savedCard ? this.savedCard.id : null,
        amount: this.amount,
      };
    },
    completeAirwallexDirectTopup(response, context, operation) {
      const validatedResponse = validateAirwallexDirectTopupResponse(
        response,
        'completion',
        operation.payment_intent_id,
      );
      const resolvedOperation = {
        ...operation,
        payment_intent_id: validatedResponse.paymentIntentId,
        support_reference: validatedResponse.supportReference
          || operation.support_reference
          || null,
        browser_confirmed: true,
      };

      if (validatedResponse.pending) {
        const pendingOperation = saveAirwallexDirectTopup(
          context,
          resolvedOperation,
        );

        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'info',
          message: [
            'Your top-up is still processing. ',
            'The same payment will be reconciled automatically.',
            creditCardPaymentSupportReferenceSuffix(
              pendingOperation.support_reference,
            ),
          ].join(''),
        });
        return pendingOperation;
      }

      const recoveryCleared = clearAirwallexDirectTopup(
        context,
        resolvedOperation,
      );
      const alreadyCompleted = validatedResponse.alreadyCompleted === true;
      let completionMessage = alreadyCompleted
        ? 'This top-up was already completed. No new charge was made.'
        : 'Your payment is submitted successfully.';

      if (!recoveryCleared) {
        completionMessage += ' Enable browser storage before starting another top-up.';
      }

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: alreadyCompleted ? 'info' : 'success',
        message: completionMessage,
      });
      this.reset();
      return resolvedOperation;
    },
    handleAirwallexDirectTopupError(error, context, operation = null) {
      let alertError = error;
      const terminalRequestError = isAirwallexTerminalRequestError(error);
      const reconciliationGuidance = !terminalRequestError && operation
        ? ` The same payment will be reconciled when you retry.${
          creditCardPaymentSupportReferenceSuffix(
            operation.support_reference,
          )
        }`
        : ' Please retry again.';

      if (!(error && error.retainAirwallexOperation)
        && terminalRequestError) {
        try {
          if (operation && operation.payment_intent_id) {
            saveAirwallexDirectTopup(context, {
              payment_operation_id: operation.payment_operation_id,
              payment_intent_id: null,
              browser_confirmed: false,
            });
          } else {
            clearAirwallexDirectTopup(context);
          }
        } catch (storageError) {
          alertError = storageError;
        }
      }

      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'error',
        message: `An error occurred ${
          toCreditCardPaymentMessage((alertError && alertError.message) || '')
        }.${reconciliationGuidance}`,
      });
    },
    submitWithSavedAirwallexCard() {
      const context = this.getAirwallexDirectTopupContext('saved');
      let operation;

      try {
        operation = getOrCreateAirwallexDirectTopup(context);
      } catch (error) {
        this.handleAirwallexDirectTopupError(error, context);
        this.loading = false;
        return Promise.resolve();
      }

      const capturePayment = () => this.$api.post('partner/payment', {
        payment_type_id: Number(this.paymentMethod),
        capture: 1,
        id: operation.payment_intent_id,
      });
      let paymentRequest;

      if (operation.payment_intent_id) {
        paymentRequest = pollAirwallexPayment(capturePayment);
      } else {
        paymentRequest = this.$api.post('partner/payment/use-saved-card', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          payment_card_id: this.savedCard.id,
          payment_operation_id: operation.payment_operation_id,
        }).then((response) => {
          const validatedResponse = validateAirwallexDirectTopupResponse(
            response,
            'completion',
          );
          const paymentIntentId = resolveAirwallexPaymentIntentId(
            validatedResponse.paymentIntentId,
            null,
            operation.payment_intent_id,
          );

          const resolvedOperation = {
            ...operation,
            payment_intent_id: paymentIntentId,
            support_reference: validatedResponse.supportReference
              || operation.support_reference
              || null,
            browser_confirmed: true,
          };

          if (!validatedResponse.pending) {
            operation = resolvedOperation;
            return response;
          }

          operation = saveAirwallexDirectTopup(
            context,
            resolvedOperation,
          );
          return pollAirwallexPayment(capturePayment, response);
        });
      }

      return paymentRequest
        .then((response) => {
          operation = this.completeAirwallexDirectTopup(
            response,
            context,
            operation,
          );
        })
        .catch((error) => {
          this.handleAirwallexDirectTopupError(error, context, operation);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitWithNewAirwallexCard() {
      const context = this.getAirwallexDirectTopupContext('new');
      let operation;

      try {
        operation = getOrCreateAirwallexDirectTopup(context);
      } catch (error) {
        this.handleAirwallexDirectTopupError(error, context);
        this.loading = false;
        return Promise.resolve();
      }

      const capturePayment = () => this.$api.post('partner/payment', {
        payment_type_id: Number(this.paymentMethod),
        capture: 1,
        id: operation.payment_intent_id,
      });
      let paymentRequest;

      if (operation.payment_intent_id && operation.browser_confirmed) {
        paymentRequest = pollAirwallexPayment(capturePayment);
      } else {
        paymentRequest = this.$api.post('partner/payment', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.amount,
          payment_operation_id: operation.payment_operation_id,
        }).then((response) => {
          const validatedResponse = validateAirwallexDirectTopupResponse(
            response,
            'authorization',
          );
          const paymentIntentId = resolveAirwallexPaymentIntentId(
            validatedResponse.paymentIntentId,
            null,
            operation.payment_intent_id,
          );

          operation = saveAirwallexDirectTopup(context, {
            ...operation,
            payment_intent_id: paymentIntentId,
            support_reference: validatedResponse.supportReference
              || operation.support_reference
              || null,
          });

          if (validatedResponse.pending) {
            operation = saveAirwallexDirectTopup(context, {
              ...operation,
              browser_confirmed: true,
            });

            return pollAirwallexPayment(capturePayment, response);
          }

          return this.$options.airwallexInterface.confirmIntent(
            operation.payment_intent_id,
            validatedResponse.clientSecret,
          ).catch((error) => {
            const confirmationError = new Error(
              (error && error.message) || 'Card confirmation failed.',
            );
            confirmationError.retainAirwallexOperation = true;
            throw confirmationError;
          }).then(() => {
            operation = saveAirwallexDirectTopup(context, {
              ...operation,
              browser_confirmed: true,
            });

            return pollAirwallexPayment(capturePayment);
          });
        });
      }

      return paymentRequest
        .then((response) => {
          operation = this.completeAirwallexDirectTopup(
            response,
            context,
            operation,
          );
        })
        .catch((error) => {
          this.handleAirwallexDirectTopupError(error, context, operation);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveCard() {
      if (this.loading || this.airwallexSavedCardsBusy) {
        return false;
      }

      if ([7, 8].includes(this.paymentMethod)) {
        return this.saveAirwallexCardOnly();
      }

      this.loading = true;
      this.saveAsDefaultCard = true;
      const { paymentMethod } = this;
      this.$api.post('partner/payment/save-card', {
        payment_type_id: paymentMethod,
      })
        .then((response) => {
          if (paymentMethod === 3) {
            this.processSaveCardStripe(response);
          }

          if (paymentMethod === 4) {
            this.processSaveCardPaypal(response);
          }
        })
        .finally(() => {
          // this.loading = false;
        });
      return true;
    },
    async saveAirwallexCardOnly() {
      if (this.airwallexWalletSelected
        || this.creditCardInvalid !== false
        || !this.airwallexInterfaceReady
      ) {
        return false;
      }

      this.loading = true;
      this.saveAsDefaultCard = true;
      try {
        await saveAirwallexCardConsent(
          this.$api,
          this.$options.airwallexInterface,
        );
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your card is saved successfully.',
        });
        this.reset();
        return true;
      } catch (error) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: airwallexCustomerErrorMessage(
            error,
            'The card could not be saved. Please try again.',
          ),
        });
        return false;
      } finally {
        this.loading = false;
      }
    },
    processSaveCardStripe(response) {
      const stripePaymentObj = {
        payment_method: {
          card: this.creditCard,
        },
      };

      if (this.saveAsDefaultCard) {
        stripePaymentObj.setup_future_usage = 'off_session';
      }

      window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
        .then(async (result) => {
          if (result.error) {
            await this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: result.error,
            });
            return;
          }

          if (result.paymentIntent.status === 'requires_capture') {
            await this.$api.post('partner/payment/save-card', {
              payment_type_id: this.paymentMethod,
              confirm: 1,
              id: result.paymentIntent.id,
            })
              .then(() => {
                const successMessage = 'Your card is saved successfully.';
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'success',
                  message: successMessage,
                });
                this.reset();
              });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    processSaveCardPaypal(response) {
      this.$set(this, 'paypalOrderId', response.data.order_id);
      this.$nextTick(() => {
        this.$options.childInterface.checkout()
          .then((payload) => {
            if (payload.liabilityShift !== 'NO'
              && payload.authenticationStatus
              && payload.authenticationStatus !== 'YES') {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: '3D Secure Authentication fails. Please retry again.',
              });
              this.loading = false;
              return;
            }

            if (payload.liabilityShift === 'NO'
              && payload.liabilityShifted === false
              && payload.authenticationStatus
              && payload.authenticationStatus === 'NO') {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: 'You have exited 3D Secure Authentication. Please retry again.',
              });
              this.loading = false;
              return;
            }

            this.$api.post('partner/payment/save-card', {
              payment_type_id: this.paymentMethod,
              confirm: 1,
              id: payload.orderId,
            })
              .then(() => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'success',
                  message: 'Your card is saved successfully.',
                });
                this.reset();
              });
          })
          .catch((error) => {
            if (error.message.indexOf('semantically incorrect') > 0
              || error.message.indexOf('not well-formed') > 0) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: `An error occurred ${error.message}. Please retry again.`,
              });
            }
            this.loading = false;
          });
      });
    },
    submit() {
      if (this.loading || this.airwallexSavedCardsBusy) {
        return;
      }

      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }

      if ([7, 8].includes(this.paymentMethod) && !isValidAirwallexTopupAmount(this.amount)) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'Enter a valid top-up amount with no more than two decimal places.',
        });
        this.loading = false;
        return;
      }

      const usingSavedCard = this.hasSavedCard
        && ((this.paymentMethod === 3 && this.stripePaymentMode === 'useSavedCard')
          || (this.paymentMethod === 7 && this.airwallexPaymentMode === 'useSavedCard'));
      const newAirwallexContext = this.getAirwallexDirectTopupContext('new');
      const newAirwallexOperation = [7, 8].includes(this.paymentMethod) && !usingSavedCard
        ? getAirwallexDirectTopup(newAirwallexContext)
        : null;
      const resumingConfirmedAirwallexPayment = newAirwallexOperation
        && newAirwallexOperation.payment_intent_id
        && newAirwallexOperation.browser_confirmed;

      if ((this.paymentMethod === 3 || [7, 8].includes(this.paymentMethod))
        && !usingSavedCard && this.creditCardInvalid
        && !resumingConfirmedAirwallexPayment) {
        this.loading = false;
        return;
      }

      if (this.paymentMethod === 1) {
        this.$api.post('partner/payment', {
          payment_type_id: this.paymentMethod,
          bank: this.bank,
          reference_no: this.referenceNo,
          transfer_datetime: this.transferDatetime,
          amount: this.amount,
        })
          .then(() => {
            const successMessage = 'Your payment is submitted successfully. Admin will review and confirm the payment.';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: successMessage,
            });
            this.reset();
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.paymentMethod === 3) {
        if (this.hasSavedCard && this.stripePaymentMode === 'useSavedCard') {
          this.$api.post('partner/payment/use-saved-card', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            payment_card_id: this.savedCard.id,
          })
            .then((response) => {
              const stripePaymentObj = {};

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                    return;
                  }

                  if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: this.paymentMethod,
                      capture: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        } else {
          this.$api.post('partner/payment', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            save_as_default_card: !this.airwallexAvailable && this.saveAsDefaultCard,
          })
            .then((response) => {
              const stripePaymentObj = {
                payment_method: {
                  card: this.creditCard,
                },
              };

              if (this.saveAsDefaultCard && !this.airwallexAvailable) {
                stripePaymentObj.setup_future_usage = 'off_session';
              }

              window.stripeClient.confirmCardPayment(response.data.client_secret, stripePaymentObj)
                .then(async (result) => {
                  if (result.error) {
                    await this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: result.error,
                    });
                    return;
                  }

                  if (result.paymentIntent.status === 'requires_capture') {
                    await this.$api.post('partner/payment', {
                      payment_type_id: this.paymentMethod,
                      capture: 1,
                      id: result.paymentIntent.id,
                    })
                      .then(() => {
                        const successMessage = 'Your payment is submitted successfully.';
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: successMessage,
                        });
                        this.reset();
                      });
                  }
                })
                .finally(() => {
                  this.loading = false;
                });
            });
        }
      }

      if (this.paymentMethod === 4) {
        if (this.hasSavedCard && this.paypalPaymentMode === 'useSavedCard') {
          this.$api.post('partner/payment/use-saved-card', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            payment_card_id: this.savedCard.id,
          })
            .then((response) => {
              this.$set(this, 'paypalOrderId', response.data.order_id);
              this.$nextTick(() => {
                this.$api.post('partner/payment/use-saved-card', {
                  payment_type_id: this.paymentMethod,
                  amount: this.amount,
                  payment_card_id: this.savedCard.id,
                  save_as_default_card: this.saveAsDefaultCard,
                  confirm: 1,
                  capture: 1,
                  id: this.paypalOrderId,
                })
                  .then(() => {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: 'Your payment is submitted successfully.',
                    });
                    this.reset();
                  })
                  .catch((error) => {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: `An error occurred ${error.message}. Please retry again.`,
                    });
                    this.loading = false;
                  });
              });
            })
            .catch((error) => {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: `An error occurred ${error.message}. Please retry again.`,
              });
              this.loading = false;
            });
        } else {
          this.$api.post('partner/payment', {
            payment_type_id: this.paymentMethod,
            amount: this.amount,
            save_as_default_card: this.saveAsDefaultCard,
          })
            .then((response) => {
              this.$set(this, 'paypalOrderId', response.data.order_id);
              this.$nextTick(() => {
                this.$options.childInterface.checkout()
                  .then((payload) => {
                    if (payload.liabilityShift !== 'NO'
                      && payload.authenticationStatus
                      && payload.authenticationStatus !== 'YES') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: '3D Secure Authentication fails. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    if (payload.liabilityShift === 'NO'
                      && payload.liabilityShifted === false
                      && payload.authenticationStatus
                      && payload.authenticationStatus === 'NO') {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'You have exited 3D Secure Authentication. Please retry again.',
                      });
                      this.loading = false;
                      return;
                    }

                    this.$api.post('partner/payment', {
                      payment_type_id: this.paymentMethod,
                      amount: this.amount,
                      save_as_default_card: this.saveAsDefaultCard,
                      confirm: 1,
                      capture: 1,
                      id: this.paypalOrderId,
                    })
                      .then(() => {
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'success',
                          message: 'Your payment is submitted successfully.',
                        });
                        this.reset();
                      })
                      .catch((error) => {
                        this.$store.dispatch('addAlert', {
                          id: Date.now(),
                          type: 'error',
                          message: `An error occurred ${error.message}. Please retry again.`,
                        });
                        this.loading = false;
                      });
                  })
                  .catch((error) => {
                    if (error.message.indexOf('semantically incorrect') > 0
                      || error.message.indexOf('not well-formed') > 0) {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                      });
                    } else {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'error',
                        message: `An error occurred ${error.message}. Please retry again.`,
                      });
                    }
                    this.loading = false;
                  });
              });
            });
        }
      }

      if (this.paymentMethod === 7 && this.hasSavedCard
        && this.airwallexPaymentMode === 'useSavedCard') {
        // The saved card shown under Airwallex may live on another module
        // (PayPal/Stripe are hidden once Airwallex is active); charge it
        // through its own module.
        if (this.savedCard.payment_type_id === 4) {
          this.submitWithSavedPaypalCard();
        } else if (this.savedCard.payment_type_id === 3) {
          this.submitWithSavedStripeCard();
        } else {
          this.submitWithSavedAirwallexCard();
        }
      } else if ([7, 8].includes(this.paymentMethod)) {
        this.submitWithNewAirwallexCard();
      }

      if (this.paymentMethod === 6) {
        this.$api.post('partner/payment', {
          payment_type_id: this.paymentMethod,
          amount: this.amount,
        })
          .then((response) => {
            if (response.data.success) {
              this.paynowImage = response.data.paynow_image;
              this.paynowReady = true;
              this.paymentId = response.data.payment_id;
              this.timer = setInterval(() => {
                this.$api.post(`partner/payment/${this.paymentId}/check-paynow-status`, {
                })
                  .then((subresponse) => {
                    if (subresponse.data.success) {
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'success',
                        message: 'Your payment is submitted successfully.',
                      });
                      this.reset();
                    }
                  });
              }, 1000);
            }
          })
          .finally(() => {
          });
      }
    },
    submitWithSavedPaypalCard() {
      this.$api.post('partner/payment/use-saved-card', {
        payment_type_id: 4,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
      })
        .then((response) => {
          this.$set(this, 'paypalOrderId', response.data.order_id);
          this.$nextTick(() => {
            this.$api.post('partner/payment/use-saved-card', {
              payment_type_id: 4,
              amount: this.amount,
              payment_card_id: this.savedCard.id,
              save_as_default_card: false,
              confirm: 1,
              capture: 1,
              id: this.paypalOrderId,
            })
              .then(() => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'success',
                  message: 'Your payment is submitted successfully.',
                });
                this.reset();
              })
              .catch((error) => {
                this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: `An error occurred ${error.message}. Please retry again.`,
                });
                this.loading = false;
              });
          });
        })
        .catch((error) => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: `An error occurred ${error.message}. Please retry again.`,
          });
          this.loading = false;
        });
    },
    submitWithSavedStripeCard() {
      this.$api.post('partner/payment/use-saved-card', {
        payment_type_id: 3,
        amount: this.amount,
        payment_card_id: this.savedCard.id,
      })
        .then((response) => {
          window.stripeClient.confirmCardPayment(response.data.client_secret, {})
            .then(async (result) => {
              if (result.error) {
                await this.$store.dispatch('addAlert', {
                  id: Date.now(),
                  type: 'error',
                  message: result.error,
                });
                return;
              }

              if (result.paymentIntent.status === 'requires_capture') {
                await this.$api.post('partner/payment', {
                  payment_type_id: 3,
                  capture: 1,
                  id: result.paymentIntent.id,
                })
                  .then(() => {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'success',
                      message: 'Your payment is submitted successfully.',
                    });
                    this.reset();
                  });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.$router.push({
        path: '/refresh',
        query: {
          path: this.$route.fullPath,
        },
      });
    },
    openDatetimePicker(event) {
      this.$refs.datetimePicker.open(event);
    },
    setSettings(settings) {
      this.form.default_ns1 = settings.ns1;
      this.form.default_ns2 = settings.ns2;
      this.form.default_ns3 = settings.ns3;
      this.form.default_ns4 = settings.ns4;
      this.form.default_ns5 = settings.ns5;
      this.form.enable_auto_topup = settings.enable_auto_topup;
      this.form.minimum_threshold_amount = settings.minimum_threshold_amount === null ? '' : settings.minimum_threshold_amount;
      this.form.auto_topup_amount = settings.auto_topup_amount === null ? '' : settings.auto_topup_amount;
      this.form.allow_threshold_email = settings.allow_threshold_email === null
        ? false : settings.allow_threshold_email;
      this.form.allow_negative_email = settings.allow_negative_email === null
        ? false : settings.allow_negative_email;
    },
    submitForm() {
      this.settingProcessing = true;
      if (this.$refs.form.validate()) {
        this.$api.put('partner/settings',
          this.form)
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Settings are updated successfully.',
            });
          }).finally(() => {
            this.settingProcessing = false;
          });
      } else {
        this.settingProcessing = false;
      }
    },
  },
  beforeDestroy() { // for Vue 2
    clearInterval(this.timer);
  },
  watch: {
    pickerTransferDatetime: {
      handler(newPickerTransferDatetime) {
        if (newPickerTransferDatetime !== null) {
          this.transferDatetime = DateTime.fromISO(newPickerTransferDatetime).toFormat('yyyy-MM-dd HH:mm:ss');
        }
      },
      deep: true,
    },
    // stripePaymentMode: {
    //   handler(newValue) {
    //     console.log(newValue);
    //   },
    // },
    // paypalPaymentMode: {
    //   handler(newValue) {
    //     console.log(newValue);
    //   },
    // },
    hasSavedCard: {
      handler(hasSavedCard) {
        if (this.airwallexWalletSelected) {
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = false;
          return;
        }
        if (this.loading) {
          return;
        }

        if (hasSavedCard) {
          this.stripePaymentMode = 'useSavedCard';
          this.paypalPaymentMode = 'useSavedCard';
          this.airwallexPaymentMode = 'useSavedCard';
          this.saveAsDefaultCard = false;
        } else {
          this.stripePaymentMode = 'useNewCard';
          this.paypalPaymentMode = 'useNewCard';
          this.airwallexPaymentMode = 'useNewCard';
          this.saveAsDefaultCard = true;
        }
      },
    },
  },
};
</script>
<style>
  .datetime-picker input {
    visibility: hidden !important;
  }
</style>
